import { observer } from 'mobx-react-lite'
import { PresetContainer, PresetList, PresetListItem } from 'shared/Preset'
import { type IIconsVector } from 'shared/ui'
import { type CreateChatbotStore } from 'pages/chatbot/store/chatbotCreateStore'
import styles from './styles.module.scss'

type IUnifiedTemplate = {
  type: string
  icon: IIconsVector
  name: string
  description: string
}

const TemplatesMap: Record<string, IUnifiedTemplate> = {
  texting: {
    type: 'texting',
    icon: 'messageTextCircle02',
    name: 'Texting',
    description: 'Automatically respond, qualify, and engage contacts',
  },
  calling: {
    type: 'calling',
    icon: 'phoneIncomingCall',
    name: 'Incoming calls',
    description: 'Answer calls, capture details, and assist callers',
  },
}

const templates = Object.values(TemplatesMap)

export const UnifiedCreateModal = observer(({ store }: { store: CreateChatbotStore }) => {
  const { onClose, createAgentModal } = store

  const onNext = (type: string) => {
    onClose()
    createAgentModal(type)
  }

  return (
    <PresetContainer>
      <PresetList className={styles.presetUnifiedList}>
        {templates.map((template) => (
          <PresetListItem
            key={template.name}
            onClick={() => onNext(template.type)}
            icon={template.icon}
            name={template.name}
            description={template.description}
          />
        ))}
      </PresetList>
    </PresetContainer>
  )
})
